import { useEffect } from 'react';

const EVFormPost = (params) => {
    useEffect(() => {
        // Programmatically submit the form after the page has loaded
        const form = document.getElementById('redirect-form');
        if (form) {
            form.submit();
        }
    }, []);

    return (
        <div className='form'>
            <form id="redirect-form" action={process.env.REACT_APP_EV_SELECT_PLAN_URL} method="POST">
                <input type="hidden" name="successCallBackURL" id="successCallBackURL" value={process.env.REACT_APP_EV_SUCCESS_CALLBACK_URL} />
                <input type="hidden" name="failureCallBackURL" id="failureCallBackURL" value={process.env.REACT_APP_EV_FAILURE_CALLBACK_URL} />
                <input type="hidden" name="accessToken" id="accessToken" value={params.token} />
                <input type="hidden" name="target" id="target" value={process.env.REACT_APP_EV_TARGET} />
                {
                    params.countryCode &&
                    <input type="hidden" name="countryCode" id="countryCode" value={params.countryCode} />
                }
                {
                    params.stateCode &&
                    <input type="hidden" name="stateCode" id="stateCode" value={params.stateCode} />
                }
                {
                    params.zipCode &&
                    <input type="hidden" name="zipCode" id="zipCode" value={params.zipCode} />
                }
                <input type="hidden" name="signature" id="signature" value={params.signature} />
            </form>
        </div>
    );
}

export default EVFormPost;